import EmailDestinatariList from "../emaildestinatari/pages/EmailDestinatariList.vue";
import EmailDestinatariEdit from "../emaildestinatari/pages/EmailDestinatariEdit.vue";

export default {
    EmailDestinatariList,
    EmailDestinatariEdit,
};